import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { stopRemoteScreenshare } from 'features/screenshare/actions';

export function* stopRemoteScreenshareSaga(action: ReturnType<typeof stopRemoteScreenshare>) {
  logger
    .remote({ action: true, tier: 1 })
    .log(`Stop screenshare remotely for the user id=${action.payload}`);

  yield call(SignalingSocket.send, {
    event: 'stopRemoteScreenshare',
    data: {
      id: action.payload,
    },
  });
}
